// navigation module vuex
export const ACLCONFIG = 'aclConfig';
export const AUTHORIZATION = 'authorization';

// mutations
export const SET_USER_ROLES = 'setUserRolesAndAuthorization';

